import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAttendanceChartData2 } from "../../../redux/reducers/apiSlice";
import {
  convertStraight,
  currentDateOfTheMonth,
} from "../../common-data/Converts";
import OnlyDateFilter from "../../pt-trials/common/OnlyDateFilter";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import ShiftTimes from "./ShiftTimes";

const CheckinsShiftwise = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();
  const { attendanceChart2, loading } = useSelector((state) => state.api);
  const initialFilters = {
    selectedStartDate: currentDateOfTheMonth,
    selectedEndDate: currentDateOfTheMonth,
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    date_from: allFilters.selectedStartDate
      ? convertStraight(allFilters.selectedStartDate)
      : "",
    date_to: allFilters.selectedEndDate
      ? convertStraight(allFilters.selectedEndDate)
      : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [shiftData, setShiftData] = useState({});

  const onClickReset = () => {
    setFilters(iniFilters);
    setAllFilters(initialFilters);
  };

  function getShiftwiseData() {
    const { date_from, date_to, start_time, end_time, ...rest } = prevFilters;
    const updatedFilters = {
      ...rest,
      chart_type: "bar",
      date_from: filters.date_from,
      date_to: filters.date_from,
    };

    dispatch(
      fetchAttendanceChartData2({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      date_from: allFilters.selectedStartDate
        ? convertStraight(allFilters.selectedStartDate)
        : "",
      date_to: allFilters.selectedEndDate
        ? convertStraight(allFilters.selectedEndDate)
        : "",
    }));
  }, [allFilters]);

  useEffect(() => {
    getShiftwiseData();
  }, [filters, prevFilters]);

  useEffect(() => {
    if (attendanceChart2?.status && attendanceChart2?.data) {
      setShiftData(attendanceChart2.data);
    } else {
      setShiftData([]);
    }
  }, [attendanceChart2]);

  return (
    <>
      <OnlyDateFilter
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        isSingleDate={true}
      />

      {loading ? <ReactVortoxSpinner /> : <ShiftTimes shiftData={shiftData} />}
    </>
  );
};

export default CheckinsShiftwise;
